import { FormControl, InputLabel, MenuItem, Select } from "@mui/material";
import { ALBUM_TYPES, ALBUM_TYPES_TEXTS } from "../../../../utils/constants/enumConstants";
import { useDispatch, useSelector } from "react-redux";
import { getSavedAlbumsTypeFilter } from "../../../../reducers/albumListState";
import { setSavedAlbumsTypeFilter } from "../../../../actions/albumListActions";

const TypeFilterInput = () => {
    const typeFilter = useSelector(getSavedAlbumsTypeFilter);

    const dispatch = useDispatch();

    const onChange = (e) => {
        dispatch(setSavedAlbumsTypeFilter(e.target.value));
    }

    return (
        <FormControl variant="standard" sx={{ minWidth: '120px', maxWidth: '150px'}} size='small'>
            <InputLabel id="album_list_filter_type_select_label">Album type</InputLabel>
            <Select multiple labelId="album_list_filter_type_select_label" value={typeFilter} onChange={onChange}>
            {
                Object.keys(ALBUM_TYPES).map((key) => <MenuItem key={key} value={key}>{ALBUM_TYPES_TEXTS[key]}</MenuItem>)
            }
            </Select>
        </FormControl>
    )
}

export default TypeFilterInput;